{
  "pt": {
    "integration": {
      "actions": {
        "goTo": "Ir para {name}"
      },
      "labels": {
        "apiTokensUsedByYou": "Tokens de API",
        "create_failed": "Falha ao criar",
        "crm_id": "{integration_oid_type} ID em {integration_name}: {integration_oid}",
        "description": "Descrição",
        "error": "erro",
        "integration": "Integração",
        "integrationOID": "ID de integração",
        "last_sync_with": "Última sincronização com {integration_name} ({last_sync_at})",
        "status": "estado",
        "synced_at": "Última sincronização: ",
        "title": "Integrações geridas pela Ziggu",
        "update_failed": "falha na atualização"
      },
      "record_actions": {
        "assign_customer": "Atribua o cliente em {integration_name}. A associação de clientes é gerida aí.",
        "delete": "Para que o {record_type} seja permanentemente eliminado no Ziggu (e não reapareça), o {record_type} <strong>deve primeiro ser eliminado no {integration_name}</strong>."
      },
      "toasts": {
        "update": "Integração atualizada"
      }
    }
  }
}
